import React, { useState } from 'react';

const CreateTestCustomer: React.FC = () => {
  const [givenName, setGivenName] = useState('Test');
  const [familyName, setFamilyName] = useState('User');
  const [email, setEmail] = useState('test@example.com');
  const [phone, setPhone] = useState('111-222-3333');
  const [customerId, setCustomerId] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/square-customer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ givenName, familyName, emailAddress: email, phoneNumber: phone })
    });
    const data = await res.json();
    setCustomerId(data.id);
    setLoading(false);
  };

  return (
    <div className="container">
      <h2>Create Dummy Square Customer</h2>
      <form onSubmit={submit}>
        <input placeholder="Given Name" value={givenName} onChange={e => setGivenName(e.target.value)} />
        <input placeholder="Family Name" value={familyName} onChange={e => setFamilyName(e.target.value)} />
        <input placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
        <input placeholder="Phone" value={phone} onChange={e => setPhone(e.target.value)} />
        <button type="submit" disabled={loading}>{loading ? 'Creating...' : 'Create Customer'}</button>
      </form>
      {customerId && <div className="alert">Customer ID: {customerId}</div>}
    </div>
  );
};
export default CreateTestCustomer;
